import { useEffect, useState } from "react";

export function FullscreenManager() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile device on load/resize
  useEffect(() => {
    const checkMobile = () => {
      const isTouch = navigator.maxTouchPoints > 0;
      const isSmallScreen = window.innerWidth < 768;
      setIsMobile(isTouch || isSmallScreen);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Listen to fullscreen changes
  useEffect(() => {
    const handleFsChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFsChange);
    return () => document.removeEventListener("fullscreenchange", handleFsChange);
  }, []);

  // Sticky behavior: if on mobile, auto-re-engage on touch/scroll if user exited
  useEffect(() => {
    if (!isMobile) return;

    const requestFs = async () => {
      if (!document.fullscreenElement) {
        try {
          await document.documentElement.requestFullscreen({ navigationUI: "hide" });
        } catch (err) {
          // Ignores silent failures if not triggered by direct gesture yet
          console.debug("[shukan] auto fullscreen request failed:", err);
        }
      }
    };

    // Listen to touchstart and scroll to enforce sticky fullscreen
    const handleGesture = () => {
      const isFsEnabledInSettings = localStorage.getItem("shukan.sticky_fullscreen") !== "false";
      if (isFsEnabledInSettings && !document.fullscreenElement) {
        requestFs();
      }
    };

    window.addEventListener("touchstart", handleGesture, { passive: true });
    window.addEventListener("scroll", handleGesture, { passive: true });

    return () => {
      window.removeEventListener("touchstart", handleGesture);
      window.removeEventListener("scroll", handleGesture);
    };
  }, [isMobile]);

  // If not mobile, we don't show any banner/toggle unless manually requested.
  // We can show a small bottom status indicator to help manual toggle.
  const toggleFullscreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen({ navigationUI: "hide" });
      } else {
        await document.exitFullscreen();
      }
    } catch (err) {
      console.error("[shukan] manual fullscreen toggle failed:", err);
    }
  };

  return null;
}
